import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3615ab28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "must-tips" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = {
  key: 0,
  class: "values",
  style: {"max-height":"200px","overflow":"auto"}
}
const _hoisted_6 = { key: 1 }

import { computed, watch, ref } from 'vue';
import { TagType } from '../../data-source/types';
import {
  BaseButton,
  BaseCascader,
  BaseCheckbox,
  BaseCheckboxGroup,
  BaseIcon,
  BaseSwitch
} from 'xrk-components';
import { CircleCloseFilled, DeleteFilled } from '@element-plus/icons-vue';
import { cloneDeep } from 'lodash';
import { useProvince } from '../../hooks/use-province';
import { OPTION_TYPE_RADIO, TAG_SOURCE_SYSTEM } from '../../config';


export default /*#__PURE__*/_defineComponent({
  __name: 'config-tags',
  props: {
    data: {},
    disabled: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emits = __emit;
const props = __props;

const _data = ref(cloneDeep(props.data));

const { addressData, addressDataChange } = useProvince(
  computed(() => _data.value.filter(item => item.isLocation)?.[0])
);

watch(
  () => _data.value,
  newV => {
    emits('change', newV);
  },
  { deep: true }
);

__expose({
  initAddressData: addressDataChange
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_data.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item",
        key: item.id
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(`${item.name}${
              item.source !== _unref(TAG_SOURCE_SYSTEM)
                ? item.optionType == _unref(OPTION_TYPE_RADIO)
                  ? '（单选）'
                  : '（多选）'
                : ''
            }`), 1),
          _createVNode(_unref(BaseSwitch), {
            disabled: _ctx.disabled,
            modelValue: item.required,
            "onUpdate:modelValue": ($event: any) => ((item.required) = $event)
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(item.required ? '必填' : '非必填'), 1),
          _createVNode(_unref(BaseButton), {
            disabled: _ctx.disabled,
            type: "info",
            link: "",
            onClick: ($event: any) => (_data.value.splice(index, 1))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseIcon), {
                color: "#777",
                size: 18
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DeleteFilled))
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]),
          (item.isLocation)
            ? (_openBlock(), _createBlock(_unref(BaseCascader), {
                key: 0,
                style: {"width":"300px"},
                disabled: _ctx.disabled,
                modelValue: item.chooseTagValues,
                "onUpdate:modelValue": ($event: any) => ((item.chooseTagValues) = $event),
                onChange: _unref(addressDataChange),
                multiple: "",
                options: _unref(addressData),
                clearable: "",
                "collapse-tags": ""
              }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange", "options"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (item.isLocation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (
                item.chooseTagValues?.length && item.chooseTagValues?.length > 0
              )
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.chooseTagValuesStr, ({
                  provinceId,
                  cityId,
                  value,
                  index
                }) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "value address-value",
                        key: index
                      }, [
                        _createElementVNode("span", null, _toDisplayString(value), 1),
                        _createVNode(_unref(BaseButton), {
                          disabled: _ctx.disabled,
                          type: "info",
                          link: "",
                          class: "del",
                          onClick: 
                    () => {
                      if (provinceId) {
                        if (cityId) {
                          item.chooseTagValues = item.chooseTagValues.filter(
                            data => data[0] != provinceId || data[1] != cityId
                          );
                        } else {
                          item.chooseTagValues = item.chooseTagValues.filter(
                            data => data[0] != provinceId
                          );
                        }
                      }
                      _unref(addressDataChange)();
                    }
                  
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(BaseIcon), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CircleCloseFilled))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, "暂未选择需求地点"))
              ]))
            : (_openBlock(), _createBlock(_unref(BaseCheckboxGroup), {
                key: 1,
                class: "values",
                modelValue: item.chooseTagValues,
                "onUpdate:modelValue": ($event: any) => ((item.chooseTagValues) = $event)
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childList, (value) => {
                    return (_openBlock(), _createBlock(_unref(BaseCheckbox), {
                      disabled: _ctx.disabled,
                      class: "value",
                      value: value.id,
                      key: value.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(value.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"]))
        ])
      ]))
    }), 128))
  ]))
}
}

})